module.exports = __webpack_public_path__ + "static/media/hotel-7.e127aefb.jpg";